import script from "./FieldBase.vue?vue&type=script&lang=js"
export * from "./FieldBase.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__